import React from 'react';
import clsx from 'clsx';
import { Card } from '../Card/Card';
import { ProcessBox } from './components/ProcessBox/ProcessBox';
import { ProcessBoxHeader } from './components/ProcessBoxHeader/ProcessBoxHeader';
import { ProcessFooter } from './components/ProcessFooter/ProcessFooter';
import { ProcessButtonsWrapper } from './components/ProcessButtonsWrapper/ProcessButtonsWrapper';
import { ProcessCardProps, ProcessCardPropsComposition } from './tools/ProcessCard.model';

import useStyles from './ProcessCard.style';

const ProcessCard: React.FC<ProcessCardProps> & ProcessCardPropsComposition = ({
  className,
  children,
  testId,
  isAllocationProcess = false
}) => {
  const c = useStyles({isAllocationProcess});

  return (
    <Card
      size='big'
      overflow='visible'
      className={clsx(className, c.root)}
      testId={testId}
    >
      {children}
    </Card>
  );
};

ProcessCard.Box = ProcessBox;
ProcessCard.BoxHeader = ProcessBoxHeader;
ProcessCard.Footer = ProcessFooter;
ProcessCard.ButtonsWrapper = ProcessButtonsWrapper;
export { ProcessCard };
